/* globals $, window, moment */
$(function () {
    "use strict";

    $('#js-cancel-car-rental').click(function(e) {
        $('#progress_modal').modal('show');
        $.ajax($(this).data('url'), {
            dataType: 'json'
        }).then(function(data) {
            if (data.success) {
                window.location = data.redirect;
            } else {
                window.alert(data.message);
                $('#modal_processing').modal('hide');
            }
        });
    });
});